
import styled from 'styled-components'

import FONTS from 'constants/fonts'
import MEDIA from 'constants/media'


export const TeamMemberTopWrap = styled.div`
  max-width: 340px;
  img {
    margin: auto;
    border-radius: 50%;
  }
`

export const TeamMemberName = styled.h3`
  font-size: ${FONTS.FONTSECTIONTITLEMOBILE};
  font-family: ${FONTS.FAMILYSECONDARY};
  margin: 20px 0 0 0;
  ${MEDIA.medium`
    font-size: ${FONTS.FONTSECTIONTITLE};
  `}
`

export const TeamMemberTitle = styled.span`
  font-size: ${FONTS.PARAGRAPHMOBILE};
  font-weight: ${FONTS.WEIGHTLIGHT};
  display: block;
  margin: 0;
  ${MEDIA.medium`
    font-size: ${FONTS.PARAGRAPH};
  `}
`
